// Estados cuota rendición calendario (concepto_detalle agrupacion 293)
export const ESTADO_CUOTA_DECLARADA       = 293001;
export const ESTADO_CUOTA_RENDIDA         = 293003;
export const ESTADO_CUOTA_VISADA          = 293004;
export const ESTADO_CUOTA_RENDIDA_PARCIAL = 293006;
export const ESTADO_CUOTA_VISADA_PARCIAL  = 293007;
